import MakeReportHub from './MakeReportHub'
export default MakeReportHub